import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/bg-search-left.webp")